// extracted by mini-css-extract-plugin
export default {"visitTypeSelectionOptionsContainer":"VisitTypeSelectionPopup_visitTypeSelectionOptionsContainer__1dpY0"};